import axios from "axios";
import { ConstVariables } from "../newComponents2/ConstantVariables";

export default axios.create({
  baseURL: ConstVariables.TV_API_URL,
});
